import { MultiDropdown } from 'src/components/dropdown/dropdown';
import { useState } from 'react';
import { DateInput } from './date';

type FormProps = {
  reportList?: string | null
}
type reportListItems = {
  required: boolean;
  name: string;
  type: string;
  options: { values: any[]; };
  display_name: string;
}


export const Form = ({ reportList }: FormProps) => {
  const [showFull, setShowFull] = useState(false)
  const formInput = {
    multidropdown: (item: reportListItems, index: number) =>
    (<div key={'report_input_' + index} className="w-1/2 px-2 py-3">
      <MultiDropdown options={item.options.values} name={item.name} label={item.display_name} required={item.required} />
    </div>
    ),
    dropdown: (item: reportListItems, index: number) => (
      <div key={'report_input_' + index} className='w-1/2 px-2 py-3'>
        <label className='block mb-2 text-xs'>{item.display_name}</label>
        <select required={item.required} name={item.name} className="border rounded-md text-xs p-2 w-full">
          {item.options.values.map((options: { name: string; id: number }, i: any) => {
            return <option key={'report_input_option_' + i} value={options.id}>{options.name}</option>
          })}
        </select>
      </div>
    ),
    date: (item: reportListItems, index: number) => <DateInput key={"date_item_" + index} item={item} index={index} />
  }
  return (
    <>
      {reportList && JSON.parse(reportList).parameters.map((item: reportListItems, index: any) => {
        if (item.required) {
          return formInput[item.type as keyof typeof formInput](item, index)
        }
      })}
      {showFull && reportList && JSON.parse(reportList).parameters.map((item: reportListItems, index: any) => {
        if (!item.required) {
          return formInput[item.type as keyof typeof formInput](item, index)
        }

      })}
      <div className='relative w-full' style={{ minHeight: '50px' }}>
        <hr className="h-px my-auto bg-cyan-200 border-0 absolute inset-0" />
        <div className='absolute z-20 m-auto inset-0 text-center'>
          <button type="button" onClick={() => setShowFull(!showFull)} className='bg-white text-cyan-400 py-3 px-2 rounded-md z-20'>نمایش {showFull ? 'کمتر' : 'بیشتر'}</button>
        </div>
      </div>
    </>
  )
}